import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import Notiflix from "notiflix";
import React, { useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

const GoldRateModal = ({ modalIsOpen, toggleGoldRateModal, onPost }) => {
  const [GoldRateState, setGoldRateState] = useState({
    todayDate: new Date(),
    GoldRate: "",
    NumRegex: /^[0-9]*$/,
  });
  var fixDate = (badDate) => {
    return badDate.toISOString().substring(0, 10);
  };
  return (
    <Modal isOpen={modalIsOpen}>
      <ModalHeader toggle={toggleGoldRateModal}>Update Gold Rate</ModalHeader>
      <ModalBody>
        <AvForm>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Date</Label>
                <input
                  type="date"
                  className="form-control"
                  value={fixDate(GoldRateState.todayDate)}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>
                  Gold Rate <span style={{ color: "red" }}>*</span>
                </Label>
                <input
                  type="text"
                  id="goldRate"
                  className="form-control"
                  value={GoldRateState.GoldRate}
                  onChange={(e) => {
                    setGoldRateState({
                      ...GoldRateState,
                      GoldRate: e.target.value,
                    });
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </AvForm>
      </ModalBody>
      <ModalFooter>
        <button
          className={"btn ml-2"}
          type="submit"
          style={{
            backgroundColor: "#880105",
            color: "#e1b761",
          }}
          onClick={() => {
            if (GoldRateState.NumRegex.test(GoldRateState.GoldRate)) {
              // api call function
              onPost(GoldRateState.todayDate, GoldRateState.GoldRate);
              // to save gold rate in backend
            } else {
              Notiflix.Notify.Failure("Please enter valid gold rate");
            }
          }}
        >
          Save
        </button>
        <Button onClick={toggleGoldRateModal}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default GoldRateModal;
